import { render, staticRenderFns } from "./NavbarNav.vue?vue&type=template&id=1c8503c4&scoped=true&"
import script from "./NavbarNav.vue?vue&type=script&lang=js&"
export * from "./NavbarNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8503c4",
  null
  
)

export default component.exports